import { authenticatedApi } from "../api";
import { MICROSERVICE_CONFIG } from "../../config/configs";

export const getMoods = async (payload) => {
	const response = await authenticatedApi.get(
		`${MICROSERVICE_CONFIG.USER}/moods${payload ? `?${payload}` : ""}`
	);
	return response.data;
};

export const addMood = async (payload) => {
	const response = await authenticatedApi.post(
		`${MICROSERVICE_CONFIG.USER}/moods`,
		payload
	);
	return response.data;
};

export const updateMood = async (payload) => {
	const { moodId, body } = payload;
	const response = await authenticatedApi.patch(
		`${MICROSERVICE_CONFIG.USER}/moods/${moodId}`,
		body
	);
	return response.data;
};
